import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DependantHeaderSample from "../common/dependantHeaderSample";
import { useEffect, useState } from "react";
import { URL } from "../../constants/constant";
import { _axios } from "../../plugins/axios";
import Table from "react-bootstrap/Table";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const OrderTracker = () => {
  const [pendingOrders, setPendingOrders] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [ordersToDisplay, setOrdersToDisplay] = useState([]);
  const [tab, setTab] = useState("pending");
  const history = useHistory();
  const fetchAllUpsellOrders = () => {
    let phleboId = JSON.parse(localStorage.getItem("user_details")).phleboId;
    let url = URL.dev_url + "phlebo-upsell-orders?phleboId=" + phleboId;
    _axios.get(url).then(function (response) {
      if (response.data.success) {
        setPendingOrders(response.data.pendingOrders);
        setOrdersToDisplay(response.data.pendingOrders);
        setCompletedOrders(response.data.completedOrders);
      }
    });
  };

  const changeTab = (tab) => {
    setTab(tab);
    if (tab == "pending") {
      setOrdersToDisplay(pendingOrders);
    } else {
      setOrdersToDisplay(completedOrders);
    }
  };

  const checkPaymentStatus = (orderId) => {
    let url = URL.dev_url + "check-payment-status?orderId=" + orderId;
    _axios.get(url).then(function (response) {
      if(response.data.isSuccess) {
        fetchAllUpsellOrders();
      }
    });
  };

  useEffect(() => {
    fetchAllUpsellOrders();
  }, []);

  return (
    <div className="order-details-dashboard p-b-10">
      <div>
        <div className="header-sample">
          <i className="fa fa-chevron-circle-left" onClick={() => history.push('/dependantOrders')}></i>
        </div>
        <DependantHeaderSample titleCall={true} noCall={true} title="Upsell Orders"></DependantHeaderSample>
      </div>
      <div>
        <Container className="m-t-10">
          <Row>
            <Button variant="danger" className="m-l-15" onClick={() => changeTab("pending")}>
              Pending Orders
            </Button>
            <Button className="m-l-15" onClick={() => changeTab("completed")}>
              Completed Orders
            </Button>
          </Row>
          <Table striped bordered responsive className="m-t-15">
            <thead>
              <tr>
                {tab === "pending" && <th>Check Payment Status</th>}
                <th>Order ID</th>
                <th>Patient Name</th>
                <th>Phone Number</th>
                <th>Creation Date</th>
              </tr>
            </thead>
            <tbody>
              {ordersToDisplay &&
                ordersToDisplay.map((order) => {
                  return (
                    <tr>
                      {tab === "pending" && (
                        <td>
                          <Button onClick={() => checkPaymentStatus(order.orderId)}>Check</Button>
                        </td>
                      )}
                      <td>{order.orderId}</td>
                      <td>{order.patientName}</td>
                      <td>{order.phoneNumber}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{moment(order.createdAt).format("DD-MM-YYYY")}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </Container>
      </div>
    </div>
  );
};

export default OrderTracker;
